import mixpanel from 'mixpanel-browser';

const analyticsEnabled = process.env.ENABLE_MIXPANEL === 'true';

export const setupAnalytics = () => {
  if (analyticsEnabled) {
    mixpanel.init(process.env.MIXPANEL_TOKEN_PROD);
  }
};

export const track = (event, properties) => {
  if (analyticsEnabled) {
    mixpanel.track(event, { ...properties });
  }
};
